import React from "react";
import { Upload } from "antd";
import uploadIcon from "../../assets/Frame.svg";
import {
  UPLOAD_SOLUTION_CONTENT,
  UPLOAD_AGENT_CONTENT,
} from "../../utils/constants";
import "./css/upload.dragger.css";

const { Dragger } = Upload;

const props = {
  name: "file",
  multiple: false,
  maxCount: 1,
  accept: ".csv",
  // action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  beforeUpload: () => false, // Prevent automatic upload
  showUploadList: false, // Hide default upload list, using custom progress bar
  onChange(info) {
    console.log("File selected:", info?.file);
  },
  onDrop(e) {
    console.log("Dropped files", e.dataTransfer.files);
  },
};

const UploadDragger = ({ handleFileUpload }) => {
  // Handle drag events
  const handleDragOver = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
  };

  const handleDragEnter = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
  };

  const customProps = {
    ...props,
    onChange(info) {
      if (handleFileUpload) {
        const fileData = {
          status: "uploading",
          name: info?.file?.name,
          size: info?.file?.size,
          percent: 0,
          response: null,
          originFileObj: info?.file?.originFileObj || info?.file,
        };

        handleFileUpload(fileData);

        // Simulate progress fill from 0 to 100%
        let currentPercent = 0;
        const progressInterval = setInterval(() => {
          currentPercent += 5;
          if (currentPercent <= 100) {
            handleFileUpload({
              ...fileData,
              percent: currentPercent,
              status: currentPercent === 100 ? "done" : "uploading",
            });
          }
          if (currentPercent >= 100) {
            clearInterval(progressInterval);
          }
        }, 50);
      }

      if (props.onChange) {
        props.onChange(info);
      }
    },
  };
  return (
    <div
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
    >
      <Dragger className="upload-dragger-container" {...customProps}>
        <div style={{ textAlign: "center" }}>
          <div className="mb-2">
            <img src={uploadIcon} alt="upload" width={32} height={32} />
          </div>
          <div className="drag-drop-text">
            {UPLOAD_SOLUTION_CONTENT.dragDropText}
          </div>
          <div className="drag-drop-text mb-4">
            {UPLOAD_SOLUTION_CONTENT.or}
          </div>
          <div
            className="browse-button mb-4"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button className="marketplace-upld-btn">
              {UPLOAD_SOLUTION_CONTENT.browseBtnLabel}
            </button>
          </div>
          <div
            className="download-link mb-3"
            onClick={(e) => {
              e?.stopPropagation();
              console.log("clicked download");
            }}
          >
            {UPLOAD_SOLUTION_CONTENT.downloadTemplate}
          </div>
          <div className="upload-restriction-txt">
            {UPLOAD_SOLUTION_CONTENT.uploadRestrictionTxt}
          </div>
        </div>
      </Dragger>
    </div>
  );
};
export default UploadDragger;
